import { useTranslations } from '@heidi/runtime/i18n';
import { Blocks, UsersRound } from 'lucide-react';
import { useMemo } from 'react';
import { useCombinedOrganizationInfo } from '../../../../../hooks/query/useCombinedOrganizationInfo';
import { type OrganizationSideNavList } from '../types';

export const useOrganizationSideNavList = () => {
  const { t } = useTranslations();
  const { isGlobalAdmin } = useCombinedOrganizationInfo();

  const organizationSideNavList: OrganizationSideNavList = useMemo(() => {
    const baseItems = [
      {
        label: t('sidenav.organization.members'),
        icon: ({ size = 12 }: { size?: number }) => (
          <UsersRound size={size} className="min-h-3 min-w-3" />
        ),
        href: '/organization/members',
      },
    ];

    // Only add templates page if user is global admin
    if (isGlobalAdmin) {
      baseItems.push({
        label: t('sidenav.organization.templates'),
        icon: ({ size = 12 }: { size?: number }) => (
          <Blocks size={size} className="min-h-3 min-w-3" />
        ),
        href: '/organization/templates-library',
      });
    }

    return [
      {
        label: t('sidenav.organization.organization'),
        items: baseItems,
      },
    ];
  }, [t, isGlobalAdmin]);

  return { organizationSideNavList };
};
